const sorting = (filtered: any, sortBy: string | null) =>
  filtered?.sort((a: any, b: any) => {
    const aDate =
      a?.cardDate || a?.textDates?.[0]?.firstActive || a?.infoPublicationDate
    const bDate =
      b?.cardDate || b?.textDates?.[0]?.firstActive || b?.infoPublicationDate

    switch (sortBy) {
      case 'random':
        return 0
      case 'name-desc':
        return a?.title?.localeCompare(b?.title as string) || 0
      case 'name-asc':
        return b?.title?.localeCompare(a?.title as string) || 0
      case 'price-desc':
        return Number(a?.price) - Number(b?.price) || 0
      case 'price-asc':
        return Number(b?.price) - Number(a?.price) || 0
      case 'date-desc':
        return new Date(aDate).getTime() - new Date(bDate).getTime()
      case 'date-asc':
        return new Date(bDate).getTime() - new Date(aDate).getTime()
      case 'distance-desc':
        if (!a?.distance || !b?.distance) {
          return 0
        }
        return Number(a.distance) - Number(b.distance)
      case 'distance-asc':
        if (!a?.distance || !b?.distance) {
          return 0
        }
        return Number(b.distance) - Number(a.distance)
      case 'duration-desc':
        if (!a?.duration || !b?.duration) {
          return 0
        }
        return Number(a.duration) - Number(b.duration)
      case 'duration-asc':
        if (!a?.duration || !b?.duration) {
          return 0
        }
        return Number(b.duration) - Number(a.duration)
      case 'difficulty-desc':
        if (a?.difficulty === 'EASY' && b?.difficulty !== 'EASY') {
          return -1
        }
        if (a?.difficulty !== 'EASY' && b?.difficulty === 'EASY') {
          return 1
        }
        if (a?.difficulty === 'INTERMEDIATE' && b?.difficulty === 'DIFFICULT') {
          return -1
        }
        if (a?.difficulty === 'DIFFICULT' && b?.difficulty === 'INTERMEDIATE') {
          return 1
        }
        return 0
      case 'difficulty-asc':
        if (a?.difficulty === 'DIFFICULT' && b?.difficulty !== 'DIFFICULT') {
          return -1
        }
        if (a?.difficulty !== 'DIFFICULT' && b?.difficulty === 'DIFFICULT') {
          return 1
        }
        if (a?.difficulty === 'INTERMEDIATE' && b?.difficulty === 'EASY') {
          return -1
        }
        if (a?.difficulty === 'EASY' && b?.difficulty === 'INTERMEDIATE') {
          return 1
        }
        return 0
      default:
        return 0
    }
  })

export default sorting
